import { useAuthContext } from "./useAuthContext";

export function useAuth() {
  const { user, idToken, loading, logout } = useAuthContext();

  return {
    user,
    idToken,
    loading,
    logout,
    isAuthenticated: !!user,
    emailVerified: user?.emailVerified ?? false,
  };
}
